import AskTheAuthorBanner from "../react_components/author/ask_the_author/banner";
import StartAnsweringButton from "../react_components/author/ask_the_author/start_answering_button";
import AskTheAuthorFeaturedAuthorContainer from "../react_components/author/ask_the_author/featured_author_container";
import AskTheAuthorCommunityQuestionAnswerContainer from "../react_components/author/ask_the_author/community_question_answer_container";
import AskTheAuthorFollowedAuthorsContainer from "../react_components/author/ask_the_author/followed_authors_container";
import LikesAndCommentsFooter from "../react_components/like/likes_and_comments_footer";
import SelectMenu from "../react_components/select_menu";

export const AuthorComponents = {
  AskTheAuthorBanner,
  StartAnsweringButton,
  AskTheAuthorFeaturedAuthorContainer,
  AskTheAuthorCommunityQuestionAnswerContainer,
  AskTheAuthorFollowedAuthorsContainer,
  LikesAndCommentsFooter,
  SelectMenu,
};

import AskTheAuthorFollowedAuthorsStore from "../react_stores/ask_the_author_followed_authors_store";
import CommentsStore from "../react_stores/comments_store";
import LikeStore from "../react_stores/like_store";

export const AuthorStores = {
  AskTheAuthorFollowedAuthorsStore,
  CommentsStore,
  LikeStore,
};
